import React from 'react';

type GeneratedBrandIconProps = {
  platform: string;
  kind: 'social' | 'streaming';
  size?: number; // px
  className?: string;
  title?: string;
  accentColor?: string; // used for bg or stroke tint
};

const ABBR_MAP: Record<string, string> = {
  // Social
  linkedin: 'IN',
  twitter: 'TW',
  instagram: 'IG',
  facebook: 'FB',
  tiktok: 'TT',
  // Streaming
  spotify: 'SP',
  youtube: 'YT',
  'youtube-music': 'YT',
  soundcloud: 'SC',
  boomplay: 'BP',
  deezer: 'DZ',
  tidal: 'TD',
  audiomack: 'AM',
};

const fallbackAbbr = (key: string) => {
  const k = (key || '').trim();
  if (!k) return '?';
  const parts = k.split(/[^a-zA-Z0-9]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return k.slice(0, 2).toUpperCase();
};

export default function GeneratedBrandIcon({ platform, size = 20, className = '', title, accentColor = '#f59e0b' }: GeneratedBrandIconProps) {
  const key = String(platform || '').toLowerCase().replace(/\s+/g, '-');
  const abbr = ABBR_MAP[key] || fallbackAbbr(key);
  const diameter = Math.max(12, Math.round(size));
  const fontSize = Math.max(8, Math.round(diameter * 0.45));

  return (
    <span
      title={title || platform}
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold select-none ${className}`}
      style={{ width: diameter, height: diameter, backgroundColor: accentColor, lineHeight: 1 }}
      aria-label={title || platform}
    >
      <span style={{ fontSize }}>{abbr}</span>
    </span>
  );
}
